import { CUE_NAMES } from './actions.js';
import { useEngineState } from './engine-state.js';
import { openSheet, type SheetName } from './ui.js';

interface ChipProps {
  sheet: SheetName;
  label: string;
  /** Said to screen readers after the label, and drawn as a mark when the setting is in use. */
  state: string | null;
  disabled?: boolean;
}

function Chip({ sheet, label, state, disabled }: ChipProps) {
  return (
    <button
      type="button"
      class="btn chip"
      aria-haspopup="dialog"
      aria-label={state ? `${label}, ${state}` : label}
      disabled={disabled}
      data-on={state ? '' : undefined}
      onClick={() => openSheet(sheet)}
    >
      {label}
    </button>
  );
}

/** The practice row: four chips, each opening a small sheet. A chip is marked when its setting is in use. */
export function PracticeRow() {
  const s = useEngineState();
  const ready = s.status === 'provisional' || s.status === 'locked';
  return (
    <div class="practice" role="group" aria-label="Practice">
      <Chip sheet="loop" label="Loop" state={s.loop.on ? `on, ${s.loop.phrases === 1 ? 'one 8-count' : `${s.loop.phrases} 8-counts`}` : null} disabled={!ready} />
      <Chip sheet="speed" label="Speed" state={s.speed < 1 ? `${Math.round(s.speed * 100)} percent` : null} />
      <Chip sheet="cues" label="Cues" state={s.cueMode !== 'off' ? CUE_NAMES[s.cueMode] : null} />
      <Chip sheet="testme" label="Test me" state={s.testMe ? `hiding ${s.testMe} 8-counts at a time` : null} disabled={!ready} />
    </div>
  );
}

